import Axios from 'axios'

export default {
  async getNewList(data) {
    let url = '/api/MenhuNews/getPageList';
    return new Promise(resolve => {
      // console.log(JSON.stringify(data));
      Axios.get(url,{params:data}).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },

  async getProductList(data) {
    let url = '/api/MenHuProduct/getPageList';
    return new Promise(resolve => {
      // console.log(JSON.stringify(data));
      Axios.get(url,{params:data}).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },

  async getNew(id) {
    let url = '/api/news/getNews?id='+id;
    return new Promise(resolve => {
      Axios.get(url).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },

  async getProduct(id) {
    let url = '/api/product/getProduct?id='+id;
    return new Promise(resolve => {
      Axios.get(url).then(response=>{
        if (response.status ===200){
          resolve(response.data)
        }
      })
    })
  },

  async getUser(){
    let api = '/api/user/getUser?userId=2';
    return new Promise((resolve,reject)=>{
      Axios.get(api).then(response=>{
        if (response.status===200){
          resolve(response.data)
        }
      })
    })
  },

  
}



// WEBPACK FOOTER //
// ./src/api/api.js